export const ADMIN_TOAST_STORAGE_KEY = "tnp-admin-toast";
export const ADMIN_SELECTED_TAB_STORAGE_KEY = "tnp-admin-selected-tab";
